import { Injectable } from '@angular/core';

import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { ErrorObservable } from 'rxjs/observable/ErrorObservable';
import { catchError, retry, map } from 'rxjs/operators';
import { ENPOINT } from "../endpoint";
import { Options } from 'selenium-webdriver/safari';


@Injectable()
export class UsersService {

  constructor(private http: HttpClient) { }

  private basePath = ENPOINT.url;

  getUsers(tipo: number, criterio: any, estatus): Observable<any> {
    // console.log(tipo);
    // console.log(criterio);
    let httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
    let options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('tipo', String(tipo))
      .set('nombre', criterio)
      .set('estatus', estatus)
    }

    return this.http.get(this.basePath + 'usuarios', options)
      .pipe();
  }

  getUserById(id: number, tipo: number, criterio: any, estatus): Observable<any>{
    // console.log(tipo);
    // console.log(criterio);
    let httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json');
    let options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('tipo', String(tipo))
      .set('nombre', criterio)
      .set('estatus', estatus)
    }
    
    return this.http.get(this.basePath + 'usuarios/' + id, options)
      .pipe();
  }


  getCustomers(usuario): Observable<any> {
    // let token = localStorage.getItem('token');
    let httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      // .set('Authorization', token);
    let options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
      .set('usuario-interno', usuario)
    }
    return this.http.get(this.basePath + 'usuarios/clientes-interno' , options)
      .pipe();
  }


  filterUsers(tipo, valor): Observable<any> {

    let httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
    let options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
        .set('tipo', tipo)
        .set('valor', valor)
    }

    return this.http.get(this.basePath + 'usuarios/clientes', options)
      .pipe();
  }



  createUser(userObj: any): Observable<any> {
    let body = userObj;
    const httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});
    const options = {
      headers: httpHeaders,
      observe: "response" as 'body',
      withCredentials: true
    };

    return this.http.post(this.basePath + 'usuarios/nuevo', body, options)
      .pipe()
  }

  updateUser(userObj: any): Observable<any> {
    // console.log(userObj);
    let body = userObj;
    const httpHeaders = new HttpHeaders({'Content-Type': 'application/json'});
    const options = {
      headers: httpHeaders,
      observe: "response" as 'body',
      withCredentials: true
    };

    return this.http.put(this.basePath + 'usuarios', body, options)
      .pipe()
  }

  // deleteUser(id){
  //   let request; 
  //   let userId = id;

  //   const headers = new HttpHeaders()
  //  .append('Content-Type' , 'application/json')
  //  .append('Accept-Language','en-US,en;q=0.5')
  //   return request = this.http.delete(this.basePath + 'users/'+userId,{ headers: headers })
  //   .pipe(
  //     retry(2)
  //   )
  // }

  deleteUser(id): Observable<any> {
    const httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
      .set('Access-Control-Allow-Origin', '*')
      .set('Access-Control-Allow-Methods', 'POST, GET, OPTIONS, PUT, DELETE')
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
        .set('idUsuario', id)
    };
    return this.http.delete(this.basePath + 'usuarios', options);
  }

  borrarUser(id: string): Observable<any> {
    const httpHeaders = new HttpHeaders().set('Content-Type', 'application/json');
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
        .set('idUsuario', id)
    };
    return this.http.delete(this.basePath + 'usuarios', options);
  }
  deleteHero(id): Observable<any> {
    const idUser = id;
    const url = `${this.basePath + 'users/'}${id}`;
    const httpOptions = {
      headers: new HttpHeaders(
        { 'Content-Type': 'application/json' },
      )
    };
    return this.http.delete(url).pipe(
      retry(2)
    );
  }



  getSociedades(): Observable<any> {
    let request;
    let httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
    let options = {
      headers: httpHeaders,
      withCredentials: true
    }

    return request = this.http.get(this.basePath + 'config/sociedades', options)
      .pipe(
        retry(3)// retry a failed request up to 3 times
        // then handle the error
      );
  }






  getCECOs(): Observable<any> {
    let request;
    let httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
    let options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
        .set('value', '')

    }

    return request = this.http.get(this.basePath + 'catalog/obtener-cecos', options)
      .pipe(
        retry(3)// retry a failed request up to 3 times
        // then handle the error
      );
  }


  getUsersPermissions(user: number): Observable<any> {
    let request;
    let httpHeaders = new HttpHeaders()
      .set('Content-Type', 'application/json')
    let options = {
      headers: httpHeaders,
      withCredentials: true,


    }

    return request = this.http.get(this.basePath + 'users/' + user + '/permisos', options)
      .pipe(
        retry(3)// retry a failed request up to 3 times
        // then handle the error
      );
  }



  estatusUsuario(id, estatus): Observable<any> {
    // let token = localStorage.getItem('token');
    // const options = {
    //   withCredentials: true,
    //   observe: "response" as 'body',
    //   headers: new HttpHeaders({
    //     'Content-Type': 'application/json',
    //     'Authorization': token,
    //   })
    // };
    const httpHeaders = new HttpHeaders();
    const options = {
      headers: httpHeaders,
      withCredentials: true,
      params: new HttpParams()
        .set('estatus', estatus)
        .set('idUsuario', id)
    };
    // console.log(token);
    return this.http.put(this.basePath + 'usuarios/estatus', '', options)
      .pipe()
  }

  agregarSociedad(valor, usuario): Observable<any>{
    // let token = localStorage.getItem('token');
    const options = {
      withCredentials: true,
      observe: "response" as 'body',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': token,
      }),
      params: new HttpParams()
        .set('usuario', usuario)
        .set('valor', valor)
    };
    return this.http.post(this.basePath + 'catalogos/agregar/sociedad', '', options)
      .pipe()
  }

  agregarOrgVentas(valor, usuario): Observable<any>{
    // let token = localStorage.getItem('token');
    const options = {
      withCredentials: true,
      observe: "response" as 'body',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': token,
      }),
      params: new HttpParams()
        .set('usuario', usuario)
        .set('valor', valor)
    };
    return this.http.post(this.basePath + 'catalogos/agregar/orgventas', '', options)
      .pipe()
  }

  agregarOfiVentas(valor, usuario): Observable<any>{
    // let token = localStorage.getItem('token');
    const options = {
      withCredentials: true,
      observe: "response" as 'body',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': token,
      }),
      params: new HttpParams()
        .set('usuario', usuario)
        .set('valor', valor)
    };
    // console.log(token);
    return this.http.post(this.basePath + 'catalogos/agregar/oficina', '', options)
      .pipe()
  }

  obtenerSociedad(usuario): Observable<any>{
    // let token = localStorage.getItem('token');
    const options = {
      withCredentials: true,
      observe: "response" as 'body',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': token,
      }),
      params: new HttpParams()
        .set('usuario', usuario)
    };
    return this.http.get(this.basePath + 'catalogos/obtener/sociedad', options)
      .pipe()
  }

  obtenerOrgVnts(usuario): Observable<any>{
    // let token = localStorage.getItem('token');
    const options = {
      withCredentials: true,
      observe: "response" as 'body',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': token,
      }),
      params: new HttpParams()
        .set('usuario', usuario)
    };
    return this.http.get(this.basePath + 'catalogos/obtener/orgventas', options)
      .pipe()
  }

  obtenerOfiVnts(usuario): Observable<any>{
    // let token = localStorage.getItem('token');
    const options = {
      withCredentials: true,
      observe: "response" as 'body',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': token,
      }),
      params: new HttpParams()
        .set('usuario', usuario)
    };
    return this.http.get(this.basePath + 'catalogos/obtener/oficina', options)
      .pipe()
  }

  eliminarSociedad(id:number, idUsuario: number): Observable<any> {
    // let token = localStorage.getItem('token');
    const options = {
      withCredentials: true,
      observe: "response" as 'body',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': token,
      }),
      params: new HttpParams()
        .set('usuario', String(idUsuario))
        .set('valor', String(id))
    };
    return this.http.delete(this.basePath + 'catalogos/eliminar/sociedad', options)
      .pipe()
  }

  eliminarOrgVentas(id:number, idUsuario: number): Observable<any> {
    // let token = localStorage.getItem('token');
    const options = {
      withCredentials: true,
      observe: "response" as 'body',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': token,
      }),
      params: new HttpParams()
        .set('usuario', String(idUsuario))
        .set('valor', String(id))
    };
    return this.http.delete(this.basePath + 'catalogos/eliminar/orgventas', options)
      .pipe()
  }

  eliminarOfiVentas(id:number, idUsuario: number): Observable<any> {
    // let token = localStorage.getItem('token');
    const options = {
      withCredentials: true,
      observe: "response" as 'body',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        // 'Authorization': token,
      }),
      params: new HttpParams()
        .set('usuario', String(idUsuario))
        .set('valor', String(id))
    };
    return this.http.delete(this.basePath + 'catalogos/eliminar/oficina', options)
      .pipe()
  }

}



// WEBPACK FOOTER //
// ./src/app/services/admin/users.service.ts